module.exports = __webpack_public_path__ + "static/img/template-img1.4a93498d.png";